import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from './sdb-colors.js';
import { elements } from './sdb-elements.js';
/**
 * Layout Grid element, used to define a grid to wrap griditems
 *
 * @slot - Unnamed slot (deafault)
 * @prop - grid4 - optional, used to create a 4 column grid (default 3)
 * @prop {String} title - optional, used to display the desired title
 * @prop {String} subtitle - optional, used to display the desired subtitle
 * @prop {Boolean} light - optional, used to display the title and subtitle in white color

 *
 */
let SDBLayoutGrid = class SDBLayoutGrid extends LitElement {
    constructor() {
        super(...arguments);
        this.grid4 = false;
        this.title = '';
        this.subtitle = '';
        this.fontSize = '';
    }
    render() {
        return html `
            ${this.title || this.subtitle
            ? html `
                      <div id="gridTitle" style="font-size:${this.fontSize};">
                          ${this.title
                ? html `<span class="title" part="title"
                                    >${this.title}</span
                                >`
                : html ``}
                          ${this.subtitle
                ? html `<span class="subtitle" part="subtitle"
                                    >${this.subtitle}</span
                                >`
                : html ``}
                      </div>
                  `
            : html ``}
            <div id="grid">
                <slot></slot>
            </div>
        `;
    }
};
SDBLayoutGrid.styles = [
    colors,
    elements,
    css `
            :host div#grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-auto-rows: auto;
                grid-auto-flow: row;
                gap: 25px 40px;
                margin: 20px 0px;
            }

            :host([grid4]) div#grid {
                grid-template-columns: repeat(4, 1fr);
            }

            @media (max-width: 1280px) {
                /* 3 columns on screens smaller then 1280px to overrule grid4 */
                :host([grid4]) div#grid {
                    grid-template-columns: repeat(3, 1fr);
                }
            }

            @media (max-width: 1024px) {
                /* 2 columns on screens smaller then 1024px*/
                :host div#grid {
                    grid-template-columns: repeat(2, 1fr);
                }
                :host([grid4]) div#grid {
                    grid-template-columns: repeat(2, 1fr);
                }
            }

            @media (max-width: 767px) {
                /* 1 column (so full width) on screens smaller then 768ox */
                :host div#grid {
                    grid-template-columns: 1fr;
                }
                :host([grid4]) div#grid {
                    grid-template-columns: 1fr;
                }
            }

            :host([light]) div#gridTitle > span {
                color: var(--text-light);
            }

            div#gridTitle {
                display: block;
                width: 100%;
                min-height: 25px;
                height: auto;
                line-height: 1em;
                color: var(--text-primary);
            }

            .title,
            .subtitle {
                color: var(--text-primary);
                display: block;
                width: auto;
            }

            .subtitle {
                font-size: 0.95em;
                font-weight: 300;
                margin: 5px 0;
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBLayoutGrid.prototype, "grid4", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGrid.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGrid.prototype, "subtitle", void 0);
__decorate([
    property({ type: String })
], SDBLayoutGrid.prototype, "fontSize", void 0);
SDBLayoutGrid = __decorate([
    customElement('sdb-layout-grid')
], SDBLayoutGrid);
export { SDBLayoutGrid };
//# sourceMappingURL=sdb-layout-grid.js.map